import { BaseEntity } from '../../models';

export class ItemMarca implements BaseEntity {
    id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    cor: string;
    ativa: boolean;
}
